import Vue from 'vue';
import BootstrapVue from "bootstrap-vue";
import App from './App.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Editor with code highlighting, supporting sparql
// https://www.npmjs.com/package/vue-codemirror
import VueCodemirror from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';

Vue.use(BootstrapVue);

Vue.use(VueAxios, axios);

Vue.use(VueCodemirror);

new Vue({
  el: '#searchapp',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js